import React, { lazy, Suspense } from "react";
var ExecutionEnvironment = require("exenv");
import CustomMeta from "../components/CustomMeta/CustomMeta";

// Componenets
const HomePage = React.lazy(() =>
  import(/* webpackChunkName: "HomePage" */ "../components/HomePage/HomePage")
);

import { makeStyles } from "tss-react/mui";

// redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()(() => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
}));

function pricing() {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Content Generator - Generate Social Media posts for eCommerce, blogs & affiliate marketing`}
        description={`Generate Social Media posts in seconds for your eCommerce store, blog, or affiliate site.`}
        url={`https://contentgenerator.io`}
      />
      <div>
        {ExecutionEnvironment.canUseDOM && (
          <Suspense fallback={<div />}>
            <HomePage />
          </Suspense>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps)(pricing);
